import React from "react";

const RightGameWrapper = ({ children }) => {
  return (
    <div className="right-cl-wrp">
      <div className="right-cl-main-cont">{children}</div>
    </div>
  );
};
export default RightGameWrapper;
